import { MainContent, TopBar } from '@domain-group/suit-theme'

import useMainNavigation from '@hooks/useMainNavigation'
import useReduxAction from '@hooks/useReduxAction'

import DashboardSearch from '@components/DashboardSearch'
import LoggedInUser from '@components/LoggedInUser'
import MainNavigation from '@sections/Client/components/MainNavigation'
import Notifications from '@components/Notifications'

import defaultRequestOptions from './defaultRequestOptions'
import AgencyMarketingRoutes from './routes'

const AgencyMarketing = () => {
  const { callbacks: { toggleNavigation } } = useMainNavigation()

  useReduxAction('brands', 'loadBrands', defaultRequestOptions.brand)

  return (
    <>
      <TopBar
        callbacks={{ toggleNavigation }}
        loggedInUserComponent={<LoggedInUser />}
        notificationsComponent={<Notifications />}
        offset={{ left: 220 }}
        searchComponent={<DashboardSearch />}
      />

      {/*
       // @ts-expect-error TS2739 */}
      <MainNavigation />

      <MainContent offset={{ left: 220, top: TopBar.topBarHeight }}>
        <AgencyMarketingRoutes />
      </MainContent>
    </>
  )
}

export default AgencyMarketing
